module.exports = __webpack_public_path__ + "static/media/fb.6c691e92.png";